import type { TaskFilters } from "@/infrastructure/repositories/tasks.supabase.repository";

export const tasksKeys = {
  all: ["tasks"] as const,
  list: (filters: TaskFilters = {}) => [...tasksKeys.all, "list", filters] as const,
  detail: (id: string) => [...tasksKeys.all, "detail", id] as const,
};
